import { scrubAnimation } from "../../ucar_lp/components/animation";

window.addEventListener("DOMContentLoaded", () => {
  const page = document.querySelector(".lpContainer");

  // ".lpContainer"がないページではここから下の処理を実行しない
  if (!page) return;

  // アニメーション実行
  scrubAnimation();
});
